// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__2cDQz","legacyBtn":"MutateMid_legacyBtn__2Lf_x"};